import { jsx as i, jsxs as C } from "react/jsx-runtime";
import * as F from "react";
import { useMemo as g, memo as P, createElement as j } from "react";
import R, { mergeStyles as w, components as b } from "react-select";
import H from "react-select/async";
import { cssColor as u } from "@stenajs-webui/theme";
import { TextInputButton as N, stenaTimes as U, Chip as O, CloseButton as V, Icon as q, stenaCheck as D, FlatButton as E } from "@stenajs-webui/elements";
import { Row as k, Space as y, Text as X, Column as Y, Spacing as I } from "@stenajs-webui/core";
import { uniqWith as J, isEqual as S, intersectionWith as L, differenceWith as K } from "lodash";
import Q from "react-select/creatable";
const W = {
  arrowColor: {
    disabled: u("--silver-light"),
    focused: {
      hover: u("--lhds-color-blue-600"),
      standard: u("--lhds-color-blue-600")
    },
    closed: {
      hover: u("--lhds-color-blue-600"),
      standard: u("--lhds-color-blue-600")
    }
  },
  clearButtonColor: {
    hover: u("--lhds-color-red-600"),
    standard: u("--lhds-color-red-500")
  },
  input: {
    backgroundColor: "var(--swui-field-bg-enabled)",
    border: "1px solid var(--swui-select-border-color)",
    borderColor: "var(--swui-field-border-color)",
    borderColorFocused: "var(--swui-field-border-color-hover)",
    disabledBackgroundColor: "var(--swui-field-bg-disabled)",
    disabledBorderColor: "var(--swui-field-bg-disabled)",
    warningBackgroundColor: "var(--swui-state-alert-light-color)",
    warningBorderColor: "var(--swui-state-alert-light-color)",
    errorBackgroundColor: "var(--swui-state-error-light-color)",
    errorBorderColor: "var(--swui-state-error-light-color)",
    successBackgroundColor: "var(--swui-state-success-light-color)",
    successBorderColor: "var(--swui-state-success-light-color)",
    boxShadowFocused: "none",
    fontFamily: "var(--swui-font-primary)",
    fontSize: "var(--swui-font-size-inputs)",
    minHeight: "24px",
    placeholderColor: "var(--swui-field-text-color)",
    textColor: "var(--swui-field-text-color)",
    borderRadius: "var(--swui-field-border-radius)"
  },
  loadingIndicator: {
    textColor: "var(--swui-field-text-color)"
  },
  groupHeading: {
    fontSize: "var(--swui-font-size-small)",
    lineHeight: "var(--swui-line-height-smaller)",
    fontWeight: "var(--swui-font-weight-text-bold)",
    color: u("--lhds-color-ui-600"),
    letterSpacing: "0.1rem"
  },
  menu: {
    activeBackgroundColor: u("--lhds-color-blue-100"),
    activeTextColor: "var(--swui-field-text-color)",
    selectedItemActiveBackgroundColor: u("--lhds-color-blue-500"),
    selectedItemActiveTextColor: u("--lhds-color-blue-50"),
    disabledTextColor: "var(--swui-field-text-color-disabled)",
    disabledBackgroundColor: "var(--swui-field-bg-disabled)",
    textColor: "var(--swui-field-text-color)",
    backgroundColor: "var(--swui-field-bg-enabled)",
    hoverTextColor: "var(--swui-field-text-color)",
    hoverBackgroundColor: u("--lhds-color-blue-200"),
    selectedItemTextColor: u("--lhds-color-blue-500"),
    selectedItemIconColor: u("--lhds-color-blue-500"),
    selectedItemHoverTextColor: "var(--swui-field-text-color)",
    selectedItemHoverIconColor: "var(--swui-field-text-color)",
    selectedItemBackgroundColor: u("--lhds-color-blue-50"),
    selectedItemHoverBackgroundColor: u("--lhds-color-blue-50"),
    zIndex: 1,
    width: "auto",
    minWidth: "100%",
    whiteSpace: "nowrap"
  },
  menuPortal: {
    zIndex: 1
  },
  multiSelect: {
    backgroundColor: "var(--swui-primary-action-color)",
    textColor: u("--lhds-color-blue-50"),
    removeButtonBackgroundColor: "transparent",
    removeButtonTextColor: "var(--swui-white)",
    removeButtonHoverBackgroundColor: "var(--swui-primary-action-color-hover)",
    removeButtonHoverTextColor: "var(--swui-white)"
  }
}, Z = (e, r, o, t) => r ? e.disabledBackgroundColor : o && t ? e.selectedItemHoverBackgroundColor : o ? e.selectedItemBackgroundColor : t ? e.hoverBackgroundColor : void 0, $ = (e, r, o, t) => r ? e.disabledTextColor : o && t ? e.selectedItemHoverTextColor : o ? e.selectedItemTextColor : t ? e.hoverTextColor : void 0, ee = (e, r, o, t) => r ? e.disabledBackgroundColor : o ? e.backgroundColor : t === "warning" ? e.warningBackgroundColor : t === "success" ? e.successBackgroundColor : t === "error" ? e.errorBackgroundColor : e.backgroundColor, M = (e, r, o, t, n) => r ? e.disabledBorderColor : o ? e.borderColorFocused : n === "warning" ? e.warningBorderColor : n === "success" ? e.successBorderColor : n === "error" ? e.errorBorderColor : t ? e.borderColorFocused : e.borderColor, oe = ({
  menu: e,
  menuPortal: r,
  input: o,
  multiSelect: t,
  clearButtonColor: n,
  arrowColor: a,
  groupHeading: c,
  loadingIndicator: m
}, f) => ({
  option: (l, { isDisabled: s, isFocused: d, isSelected: h }) => ({
    ...l,
    fontFamily: o.fontFamily,
    fontSize: o.fontSize,
    backgroundColor: Z(
      e,
      s,
      h,
      d
    ),
    color: $(e, s, h, d),
    cursor: s ? "not-allowed" : "default",
    whiteSpace: e.whiteSpace || l.whiteSpace,
    ":active": {
      backgroundColor: s ? void 0 : h ? e.selectedItemActiveBackgroundColor : e.activeBackgroundColor,
      color: s ? void 0 : h ? e.selectedItemActiveTextColor : e.activeTextColor
    }
  }),
  control: (l, { isFocused: s, isDisabled: d, menuIsOpen: h }) => ({
    ...l,
    // none of react-selects styles are passed to <View />
    fontFamily: o.fontFamily,
    fontSize: o.fontSize,
    minHeight: "var(--swui-field-height)",
    backgroundColor: ee(
      o,
      d,
      s,
      f
    ),
    borderRadius: o.borderRadius,
    border: o.border,
    "--swui-select-border-color": M(
      o,
      d,
      s || h,
      !1,
      f
    ),
    outline: s ? "var(--swui-focus-outline)" : void 0,
    outlineOffset: s ? "-1px" : void 0,
    transition: "none",
    boxShadow: s ? o.boxShadowFocused : void 0,
    "&:hover": {
      "--swui-select-border-color": M(
        o,
        !1,
        s || h,
        !0,
        f
      )
    }
  }),
  singleValue: (l) => ({
    ...l,
    fontFamily: o.fontFamily,
    fontSize: o.fontSize,
    color: o.textColor
  }),
  noOptionsMessage: (l) => ({
    ...l,
    fontFamily: o.fontFamily,
    fontSize: o.fontSize
  }),
  input: (l) => ({
    ...l,
    padding: 0,
    margin: 0,
    minHeight: o.minHeight,
    fontFamily: o.fontFamily,
    fontSize: o.fontSize,
    color: o.textColor
  }),
  groupHeading: (l) => ({
    ...l,
    fontFamily: o.fontFamily,
    fontSize: c.fontSize,
    lineHeight: c.lineHeight,
    fontWeight: c.fontWeight,
    color: c.color,
    letterSpacing: c.letterSpacing
  }),
  multiValueLabel: (l) => ({
    ...l,
    backgroundColor: t.backgroundColor,
    color: t.textColor,
    fontFamily: o.fontFamily,
    fontSize: c.fontSize
  }),
  indicatorSeparator: (l) => ({
    ...l,
    display: "none"
  }),
  clearIndicator: (l) => ({
    ...l,
    padding: "5px",
    color: n.standard,
    "&:hover": {
      color: n.hover
    },
    cursor: "pointer"
  }),
  placeholder: (l) => ({
    ...l,
    fontFamily: o.fontFamily,
    fontSize: o.fontSize,
    color: o.placeholderColor
  }),
  container: (l) => ({
    ...l
  }),
  valueContainer: (l) => ({
    ...l,
    padding: "var(--swui-metrics-space-half) var(--swui-metrics-space)",
    gap: "var(--swui-metrics-space-half)"
  }),
  dropdownIndicator: (l, { isFocused: s, isDisabled: d }) => ({
    ...l,
    padding: "5px",
    color: d ? a.disabled : s ? a.focused.standard : a.closed.standard,
    "&:hover": {
      color: d ? a.disabled : s ? a.focused.hover : a.closed.hover
    },
    svg: {
      width: 14,
      height: 14
    }
  }),
  menu: (l) => ({
    ...l,
    backgroundColor: e.backgroundColor,
    color: e.textColor,
    minWidth: e.minWidth || l.minWidth,
    zIndex: e.zIndex,
    width: e.width || l.width,
    border: o.border,
    borderColor: o.borderColorFocused
  }),
  menuPortal: (l) => ({
    ...l,
    zIndex: r.zIndex
  }),
  multiValueRemove: (l) => ({
    ...l,
    backgroundColor: t.removeButtonBackgroundColor,
    ":hover": {
      color: t.removeButtonHoverTextColor,
      backgroundColor: t.removeButtonHoverBackgroundColor
    },
    color: t.removeButtonTextColor,
    borderRadius: "50%",
    width: 16,
    height: 16,
    padding: 0,
    margin: 3,
    marginTop: 4,
    display: "flex",
    justifyContent: "center",
    alignItems: "center",
    cursor: "pointer"
  }),
  multiValue: (l) => ({
    ...l,
    backgroundColor: t.backgroundColor,
    color: t.textColor,
    fontFamily: o.fontFamily,
    fontSize: c.fontSize,
    alignItems: "center",
    margin: 0,
    borderRadius: "var(--swui-border-radius-small)",
    overflow: "hidden"
  }),
  loadingMessage: (l) => ({
    ...l,
    color: m.textColor,
    fontFamily: o.fontFamily,
    fontSize: o.fontSize
  })
}), x = (e) => oe(W, e);
function ye({
  variant: e = "standard",
  styles: r,
  isMulti: o,
  ...t
}) {
  const n = g(() => {
    const a = x(e);
    return r ? w(a, r) : a;
  }, [e, r]);
  return /* @__PURE__ */ i(H, { styles: n, ...t, isMulti: !0 });
}
function Be({
  variant: e = "standard",
  styles: r,
  isMulti: o,
  ...t
}) {
  const n = g(() => {
    const a = x(e);
    return r ? w(a, r) : a;
  }, [e, r]);
  return /* @__PURE__ */ i(H, { styles: n, ...t, isMulti: !1 });
}
const re = function({
  clearValue: e
}) {
  return (
    // stopPropagation is needed to prevent react-select from opening its menu when clicking on the button.
    /* @__PURE__ */ i("div", { onMouseDown: (r) => r.stopPropagation(), children: /* @__PURE__ */ i(
      N,
      {
        "aria-label": "Clear",
        onClick: e,
        icon: U,
        variant: "error"
      }
    ) })
  );
}, te = function({
  removeProps: e,
  data: r
}) {
  return (
    // stopPropagation is needed to prevent react-select from opening its menu when clicking on the button.
    /* @__PURE__ */ i("div", { onMouseDown: (o) => o.stopPropagation(), children: /* @__PURE__ */ i(
      O,
      {
        onClickRemove: (o) => {
          var t;
          return (t = e.onClick) == null ? void 0 : t.call(
            e,
            o
          );
        },
        label: r.label
      }
    ) })
  );
};
function B({
  variant: e = "standard",
  styles: r,
  isMulti: o,
  components: t,
  ...n
}) {
  const a = g(() => {
    const c = x(e);
    return r ? w(c, r) : c;
  }, [e, r]);
  return /* @__PURE__ */ i(
    R,
    {
      styles: a,
      components: { ...t, ClearIndicator: re, MultiValue: te },
      ...n,
      isMulti: !0
    }
  );
}
function ze(e) {
  return /* @__PURE__ */ i(
    B,
    {
      hideSelectedOptions: !1,
      ...e,
      components: {
        ...e.components,
        ValueContainer: le
      }
    }
  );
}
const le = P(
  (e) => {
    const [r, ...o] = e.children, t = ne(r, e);
    return /* @__PURE__ */ C(b.ValueContainer, { ...e, children: [
      t,
      o
    ] });
  }
), ne = (e, {
  children: r,
  innerProps: o,
  className: t,
  ...n
}) => e ? e.length > 1 ? [
  e[0],
  /* @__PURE__ */ j(
    b.MultiValue,
    {
      ...n,
      key: "DUMMY_VALUE_FOR_PLUS_X",
      innerProps: {},
      data: null,
      isFocused: !1,
      removeProps: {},
      index: 1,
      components: {
        Container: b.MultiValueContainer,
        Label: b.MultiValueLabel,
        Remove: () => /* @__PURE__ */ i("div", { style: { height: 16, margin: 3, marginTop: 4 } })
      }
    },
    "+" + (e.length - 1)
  )
] : e : null;
function Me({
  variant: e = "standard",
  styles: r,
  isMulti: o,
  components: t,
  ...n
}) {
  const a = g(() => {
    const m = x(e);
    return r ? w(m, r) : m;
  }, [e, r]);
  return /* @__PURE__ */ i(
    R,
    {
      styles: a,
      components: { ...t, ClearIndicator: (m) => /* @__PURE__ */ i(V, { "aria-label": "Clear", onClick: m.clearValue }) },
      ...n,
      isMulti: !1
    }
  );
}
const T = (e, r) => K(
  r,
  [...e.internalOptions, e],
  S
).map(p), ie = (e) => !("internalOptions" in e), v = (e) => e.filter(ie).map(p), ae = (e) => (r, o) => {
  const t = r ?? [];
  switch (o.action) {
    case "select-option":
      if (o.option && "internalOptions" in o.option) {
        const n = J(
          t.reduce(
            (a, c) => "internalOptions" in c ? [...a, ...c.internalOptions] : [
              ...a,
              p(c)
            ],
            []
          ),
          S
        );
        e(n, o);
      } else
        e(v(t), o);
      break;
    case "deselect-option":
      o.option && "internalOptions" in o.option ? e(
        T(
          o.option,
          v(t)
        ),
        o
      ) : e(v(t), o);
      break;
    case "remove-value":
    case "pop-value":
      o.removedValue && "internalOptions" in o.removedValue ? e(
        T(
          o.removedValue,
          v(t)
        ),
        o
      ) : e(v(t), o);
      break;
    case "clear":
      e(
        t.map(p),
        o
      );
      break;
    case "create-option":
      e(
        t.map(p),
        o
      );
      break;
  }
}, ce = (e) => e.reduce(
  (r, o) => [
    ...r,
    A(o),
    ...o.options.map(G)
  ],
  []
), se = (e, r) => {
  if (!r)
    return [];
  const o = [];
  return e.forEach((t) => {
    de(t.options, r) && o.push(
      A(t)
    ), o.push(
      ...L(t.options, r, S).map(
        (n) => G(n)
      )
    );
  }), o;
}, de = (e, r) => r ? L(e, r, S).length === e.length : !1, G = (e) => ({
  data: e.data,
  label: e.label,
  value: e.value
}), A = (e) => ({
  data: e.label,
  label: e.label,
  value: e.label,
  internalOptions: e.options
}), p = (e) => ({
  data: e.data,
  label: e.label,
  value: e.value
}), ue = (e, r) => r ? e.menu.selectedItemHoverIconColor : e.menu.selectedItemIconColor;
function fe(e) {
  const { formatGroupLabel: r, formatOptionLabel: o } = e.selectProps;
  return "internalOptions" in e.data ? r ? r({
    label: e.data.label,
    options: e.data.internalOptions
  }) : e.label : o ? o(e.data, {
    context: "menu",
    inputValue: e.selectProps.inputValue ?? "",
    selectValue: e.getValue()
  }) : e.label;
}
function me({
  onChange: e,
  options: r,
  value: o,
  variant: t = "standard",
  formatGroupLabel: n,
  formatOptionLabel: a,
  ...c
}) {
  const m = (d) => {
    const h = fe(d), z = "internalOptions" in d.data;
    return /* @__PURE__ */ i(b.Option, { ...d, children: /* @__PURE__ */ C(k, { children: [
      !z && /* @__PURE__ */ i(y, {}),
      /* @__PURE__ */ i(
        he,
        {
          theme: W,
          size: z ? void 0 : "small",
          label: h,
          selected: d.isSelected,
          focused: d.isFocused
        }
      )
    ] }) });
  }, f = (d) => "internalOptions" in d.data ? null : /* @__PURE__ */ i(b.MultiValue, { ...d }), l = r ? se(r, o) : void 0, s = r ? ce(r) : void 0;
  return /* @__PURE__ */ i(
    B,
    {
      ...c,
      onChange: e ? ae(e) : void 0,
      hideSelectedOptions: !1,
      components: {
        ...c.components,
        MultiValue: f,
        Option: m
      },
      isMulti: !0,
      options: s,
      value: l,
      variant: t
    }
  );
}
const he = ({
  focused: e,
  label: r,
  selected: o,
  size: t,
  theme: n
}) => /* @__PURE__ */ C(k, { alignItems: "center", justifyContent: "space-between", flexGrow: 1, children: [
  /* @__PURE__ */ i(X, { tabIndex: -1, size: t, color: "currentColor", children: r }),
  o && /* @__PURE__ */ i(
    q,
    {
      color: ue(n, e),
      icon: D,
      size: 12
    }
  )
] });
function Te({
  variant: e = "standard",
  styles: r,
  isMulti: o,
  components: t,
  ariaLabelClear: n = "Clear",
  ...a
}) {
  const c = g(() => {
    const f = x(e);
    return r ? w(f, r) : f;
  }, [e, r]);
  return /* @__PURE__ */ i(
    Q,
    {
      styles: c,
      components: { ...t, ClearIndicator: (f) => /* @__PURE__ */ i(V, { "aria-label": n, onClick: f.clearValue }) },
      ...a,
      isMulti: !1
    }
  );
}
function _({
  value: e,
  onValueChange: r,
  noneSelectedLabel: o = "None",
  children: t
}) {
  return /* @__PURE__ */ C(Y, { flex: 1, children: [
    /* @__PURE__ */ C(k, { flexWrap: "wrap", children: [
      e == null ? void 0 : e.map((n) => /* @__PURE__ */ C(k, { children: [
        /* @__PURE__ */ i(I, { num: 0.5, children: /* @__PURE__ */ i(
          O,
          {
            label: n.label,
            onClickRemove: () => r == null ? void 0 : r(
              (e == null ? void 0 : e.filter((a) => a.value !== n.value)) ?? []
            )
          }
        ) }),
        /* @__PURE__ */ i(y, {})
      ] }, n.value)),
      e != null && e.length ? /* @__PURE__ */ i(I, { num: 0.5, children: /* @__PURE__ */ i(
        E,
        {
          size: "small",
          label: "Clear",
          onClick: () => r == null ? void 0 : r([])
        }
      ) }) : /* @__PURE__ */ i(I, { num: 0.5, children: /* @__PURE__ */ i(O, { variant: "secondary", label: o }) })
    ] }),
    /* @__PURE__ */ i(y, { num: 0.5 }),
    t
  ] });
}
function Ce({
  value: e,
  onValueChange: r,
  placeholder: o = "Type to search",
  loading: t,
  inputValue: n,
  onInputChange: a,
  noneSelectedLabel: c = "None",
  ...m
}) {
  return /* @__PURE__ */ i(
    _,
    {
      noneSelectedLabel: c,
      onValueChange: r,
      value: e,
      children: /* @__PURE__ */ i(
        B,
        {
          ...m,
          isClearable: !1,
          value: e,
          onChange: r ? (f) => r([...f]) : void 0,
          backspaceRemovesValue: !1,
          hideSelectedOptions: !0,
          controlShouldRenderValue: !1,
          placeholder: o,
          isLoading: t,
          inputValue: n,
          onInputChange: a
        }
      )
    }
  );
}
const Fe = F.memo(
  Ce
);
function be({
  value: e,
  onValueChange: r,
  placeholder: o = "Type to search",
  loading: t,
  inputValue: n,
  onInputChange: a,
  noneSelectedLabel: c = "None",
  ...m
}) {
  return /* @__PURE__ */ i(
    _,
    {
      noneSelectedLabel: c,
      onValueChange: r,
      value: e,
      children: /* @__PURE__ */ i(
        me,
        {
          ...m,
          isClearable: !1,
          value: e,
          onChange: r ? (f) => r([...f]) : void 0,
          backspaceRemovesValue: !1,
          hideSelectedOptions: !0,
          controlShouldRenderValue: !1,
          placeholder: o,
          isLoading: t,
          inputValue: n,
          onInputChange: a
        }
      )
    }
  );
}
const Re = F.memo(
  be
);
export {
  ye as AsyncMultiSelect,
  Be as AsyncSelect,
  Fe as ChipMultiSelect,
  Te as CreatableSelect,
  Re as GroupedChipMultiSelect,
  me as GroupedMultiSelect,
  B as MultiSelect,
  ze as OverflowingMultiSelect,
  Me as Select,
  oe as createStylesFromTheme,
  x as createStylesFromVariant,
  W as defaultSelectTheme
};
//# sourceMappingURL=index.es.js.map
